// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kd48","right":"Footer_right__19Oqp","buttons":"Footer_buttons__9jrbG"};